<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox"
      :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog NCAcmi_cont02_popUp">
        <div class="cart-popup__header">
          <span class="cart-popup__header-text" style="color:#2c2c2c;">
            NHN KCP 11월 신용카드 <em class="fntH5 fntL bold">무이자 할부</em> 이벤트
            <a @click="closePopup" data-dismiss="modal" aria-label="Close" aria-hidden="true" class="cart-popup__close">
              <img src="@/views/survey2/images/NCAcmi_close.png" alt="닫기">
            </a>
          </span>
        </div>
        <div class="cart-popup__content payment">
          <div class="cart-popup__item-info amway-theme" style="padding:0;">
            <div class="os_noticeRes" style="padding: 10px 15px 10px;">
              <div class="widM">
                <p class="fntP marTM marBSM" style="color:#2c2c2c;">
                  행사기간: 2022년 11월 1일 ~ 2022년 11월 30일<br>
                  행사내용: <em class="colorBlue">NHN KCP 가맹점 결제 이용 시 무이자 할부</em>
                </p>
                <div class="osResTbBlock marTM">
                  <table class="osResTb05 txtC">
                    <caption>
                      <p class="hide">동반가족 추가금액 안내에 관한 연령, 추가 금액 으로 구성된 표입니다.</p>
                    </caption>
                    <colgroup>
                      <col style="width:49%;">
                      <col style="width:auto;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">카드사</th>
                        <th scope="col">행사내용</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="verM">롯데카드</td>
                        <td class="txtL">5만원 이상 결제 시<br><em class="colorBlue">2 ~ 4개월 무이자 할부</em></td>
                      </tr>
                      <tr>
                        <td class="verM">삼성카드</td>
                        <td class="txtL">5만원 이상 결제 시<br><em class="colorBlue">2 ~ 3개월 무이자 할부</em><br>6개월: 1 ~ 3회차 수수료 고객부담<br>*잔여회차 삼성카드 부담</td>
                      </tr>
                      <tr>
                        <td class="verM">신한카드</td>
                        <td class="txtL">5만원 이상 결제 시<br><em class="colorBlue">2 ~ 3개월 무이자 할부</em></td>
                      </tr>
                      <tr>
                        <td class="verM">BC카드/KB국민카드</td>
                        <td class="txtL">5만원 이상 결제 시<br><em class="colorBlue">2 ~ 7개월 무이자 할부</em></td>
                      </tr>
                      <tr>
                        <td class="verM">하나카드/NH농협카드</td>
                        <td class="txtL">5만원 이상 결제 시<br><em class="colorBlue">2 ~ 8개월 무이자 할부</em></td>
                      </tr>
                      <tr>
                        <td class="verM">현대카드</td>
                        <td class="txtL">1만원 이상 결제 시<br><em class="colorBlue">2 ~ 7개월 무이자 할부</em></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="padTS fntE">* 사업장(법인, 개인), 체크, 선불, 기프트카드는 제외됩니다.<br>
                  * 무이자 이용 시 포인트/마일리지 적립/할인 서비스 등 다른 혜택과 중복 적용되지 않습니다.<br>
                  * 직계약 가맹점 및 상점 부담 무이자 가맹점, 특별 제휴 가맹점 등 일부 가맹점은 제외될 수 있습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SURVEY, TOGGLE_INTEREST_FEE_POPUP } from '@/store/actions/survey'
import { PopupMixin } from '../mixins'

export default {
  name: 'SurveyPopupLayerInterestFee',
  mixins: [PopupMixin],
  methods: {
    closePopup() {
      this.$store.commit(`${SURVEY}/${TOGGLE_INTEREST_FEE_POPUP}`, false);
    }
  },
  mounted() {
    window.addEventListener('resize', this.layerTypeBasic);
    this.layerTypeBasic();
  },
  destroyed() {
    window.removeEventListener('resize', this.layerTypeBasic);
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyPopupLayerInterestFee.vue